// Meta Pixel utility functions
// Pixel ID: 1460293155735606

declare global {
  interface Window {
    fbq: any
    _fbq: any
  }
}

// Initialize Meta Pixel - call this once on app load
export function initMetaPixel(): void {
  if (typeof window === 'undefined') return

  // If already initialized, don't re-initialize
  if (window.fbq && window.fbq.loaded) return

  // Meta Pixel base code (exact pattern from Facebook)
  ;(function (f: any, b: Document, e: string, v: string) {
    let n: any, t: HTMLScriptElement, s: Element | null

    if (f.fbq) return

    n = f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
    }

    if (!f._fbq) f._fbq = n
    n.push = n
    n.loaded = !0
    n.version = '2.0'
    n.queue = []

    t = b.createElement(e) as HTMLScriptElement
    t.async = !0
    t.src = v

    s = b.getElementsByTagName(e)[0]
    if (s && s.parentNode) {
      s.parentNode.insertBefore(t, s)
    } else {
      b.head.appendChild(t)
    }
  })(
    window,
    document,
    'script',
    'https://connect.facebook.net/en_US/fbevents.js',
  )

  // Initialize pixel with your ID
  window.fbq('init', '1460293155735606')

  // Track PageView immediately after init (will be queued and processed when script loads)
  window.fbq('track', 'PageView')

  console.log('[Meta Pixel] Initialized with ID: 1460293155735606')
}

// Track AddToCart event
export function trackAddToCart(params?: {
  content_name?: string
  content_ids?: string[]
  content_type?: string
  value?: number
  currency?: string
}): void {
  if (typeof window === 'undefined' || !window.fbq) {
    console.warn('[Meta Pixel] fbq not available')
    return
  }

  const eventParams = params || {
    content_name: '3AM Otra Vez - Protocolo de Sueño',
    content_ids: ['51116124078378'],
    content_type: 'product',
    value: 6.39,
    currency: 'USD',
  }

  window.fbq('track', 'AddToCart', eventParams)
  console.log('[Meta Pixel] AddToCart event fired', eventParams)
}

// Generic track function for custom events
export function trackEvent(
  eventName: string,
  params?: Record<string, any>,
): void {
  if (typeof window === 'undefined' || !window.fbq) {
    console.warn('[Meta Pixel] fbq not available')
    return
  }

  if (params) {
    window.fbq('track', eventName, params)
  } else {
    window.fbq('track', eventName)
  }
  console.log(`[Meta Pixel] ${eventName} event fired`, params)
}
